import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { ProjectState } from 'store/Project/ProjectTypes'

type Args = {
  shallUpdateOperationsSummary?: boolean
  shallUpdateOperationsLogs?: boolean
  isExportingToErp?: boolean
  isNesting?: boolean
  isManufacturabilityCheckRunning?: boolean
}

export const updateOperationsFlags: CaseReducer<
  ProjectState,
  PayloadAction<Args>
> = (state, action) => {
  state.projectOperations.isExportingToErp =
    action.payload.isExportingToErp ?? state.projectOperations.isExportingToErp
  state.projectOperations.isNesting =
    action.payload.isNesting ?? state.projectOperations.isNesting
  state.projectOperations.isManufacturabilityCheckRunning =
    action.payload.isManufacturabilityCheckRunning ??
    state.projectOperations.isManufacturabilityCheckRunning

  state.projectOperations.shallUpdateSummary =
    action.payload.shallUpdateOperationsSummary ??
    state.projectOperations.shallUpdateSummary ??
    false

  state.projectOperations.shallUpdateOperations =
    action.payload.shallUpdateOperationsLogs ??
    state.projectOperations.shallUpdateOperations ??
    false

  return state
}
